import React from 'react';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { WorkerListCard } from './WorkerListCard';
import { PsPage } from '../../../shared/components/ps-page/PsPage';
import { BreadcrumbsManagerInstance } from '../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../shared/breadcrumbs/Breadcrumbs';
import { CardStorageManager } from '../../../shared/utils/CardStorageManager';

export class WorkerListScreen extends React.Component {

    cardStorageManager = new CardStorageManager(this.props.location.pathname);

    constructor(props) {
        super(props);

        this.cardStorageManager.init();

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_WORKERS,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_TRABAJADORES_DE_MIS_SUBCONTRATAS')} breadcrumbs={breadcrumbs}>
                <WorkerListCard
                    saveCardState={this.saveCardState}
                    initialCardState={this.readCardState()}
                />
            </PsPage>
        );
    }

    saveCardState = (state) => {
        this.cardStorageManager.saveCard('outsourceWorkers', state);
    };

    readCardState = () => {
        return this.cardStorageManager.readCard('outsourceWorkers');
    };
}

WorkerListScreen.propTypes = {};

WorkerListScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/worker/list/WorkerListScreen.jsx